import {needAuth} from "../instance/Instance";


const getAllMenus = async () => {
    try{
        return await needAuth.get(`/menus`);
    }catch (error){
        return error;
    }
}

const getMenusByUserGroup = async () => {
    try {
        return await needAuth.get(`/menus/userGroups`)
    } catch (error) {
        return error;
    }
}

export {getAllMenus, getMenusByUserGroup};